__turbopack_context__.v({
  "button": "show-more-button-module-scss-module__Cwz5Dq__button",
});
